/**
 * @desc FBA月度盘点-查询是否可以创建FBA月度盘点
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(options?: any) {
  return updateResponse(
    http(URL + `/fulfilment/amazonInventoryMonthly/queryCanCreate`, {
      method: "GET",

      ...options,
    }),
  );
}
